import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from 'styled-components';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#26ffc9',
      main: '#537ccd',
      dark: '#26ffc9',
      contrastText: '#fff',
      white: 'white',
    },
    error: {
      main: '#f44336',
    },
  },
  typography: {
    fontFamily: '"Open Sans", "Helvetica", "Arial", sans-serif',
    fontWeightStrong: 600,
  },
  overrides: {
    MuiTablePagination:{
      actions: {
        marginLeft: '0',
      }
    }	
  }
});

function withRoot(Component) {
  function WithRoot(props) {
    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <Component {...props} />
        </MuiThemeProvider>
      </ThemeProvider>
    );
  }

  return WithRoot;
}

export default withRoot;
